var cell_default = {
  "cell": "_3gb4z",
  "header": "GHekb",
  "selected": "XeOuF",
  "editing": "b1Okh",
  "singleSelection": "UEmy4",
  "hideLastBlock": "U0iw7",
  "editorWrapper": "Y8shc",
  "viewerWrapper": "jtNen",
  "hideFirstBlock": "sBuPx",
  "editor": "OTXwc",
  "edit": "Nt97j",
  "view": "J3C0-",
  "editingToolbarWrapper": "q8yBi",
  "selectAll": "hP9G2",
  "disableSelection": "ZEQwj"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
